// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
   REGISTRATION_URL: "http://103.11.152.158:4075/",
   GRIEVANCE_URL: "http://localhost:38089",
   APPLICATION_URL: "http://103.11.152.158:4077"
//  REGISTRATION_URL: "https://democsmcregistration.probitysoftware.in/",
//   GRIEVANCE_URL: "http://103.11.152.158:8091/secure/grievance",
//   APPLICATION_URL: "https://democsmcapplication.probitysoftware.in"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
